import React from 'react';
import { useDispatch } from 'react-redux';
import { fetchTimelineData } from '@store/timeline/data/actions';
import Timeline from '@components/session-timeline';
import { PAGE_TYPE } from '@utils/constants';
import TimelinePageStyled from './styled';

function TempTimelineTab() {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(fetchTimelineData(PAGE_TYPE.TEMP_DASHBOARD));
  }, [dispatch]);

  return (
    <TimelinePageStyled>
      <Timeline id="new-timeline-tab" isSharing={false} pageType={PAGE_TYPE.TEMP_DASHBOARD} />
    </TimelinePageStyled>
  );
}

export default TempTimelineTab;
